export const isProduction = process.env.NODE_ENV === "production"
export const staticUrl = isProduction
  ? //"/static/react/" ||
  "XXX_PUBLIC_URL_XXX/"
  : "http://front.etvnet.com/static/react/" ||
  "http://localhost:8020/static/react/"

export const defaultCookieDomain = ".etvnet.com"
